<template>
  
          <h6 class="text-center mb-4">What would you like to do next?</h6>
          
          <div class="row g-3">
            <!-- Create New -->
            <div class="col-md-6">
              <div class="card h-100 option-card" @click="selectOption('create')">
                <div class="card-body text-center">
                  <i class="bi bi-plus-circle-fill text-primary option-icon"></i>
                  <h5>Create New</h5>
                  <p class="text-muted">Start a new transaction</p>
                </div>
              </div>
            </div>
            
            <!-- Print Only -->
            <div class="col-md-6">
              <div class="card h-100 option-card" @click="selectOption('print')">
                <div class="card-body text-center">
                  <i class="bi bi-printer-fill text-success option-icon"></i>
                  <h5>Print Receipt</h5>
                  <p class="text-muted">Print current document</p>
                </div>
              </div>
            </div>
            
            <!-- Print & New -->
            <div class="col-md-6">
              <div class="card h-100 option-card" @click="selectOption('review')">
                <div class="card-body text-center">
                  <i class="bi bi-bag-check-fill text-info option-icon"></i>
                  <h5>Review Record</h5>
                  <p class="text-muted">Review entries</p>
                </div>
              </div>
            </div>
            
            <!-- Cancel -->
            <div class="col-md-6">
              <div class="card h-100 option-card" @click="selectOption('cancel')">
                <div class="card-body text-center">
                  <i class="bi bi-x-circle-fill text-danger option-icon"></i>
                  <h5>Close</h5>
                  <p class="text-muted">Return to page</p>
                </div>
              </div>
            </div>
          </div>
        
</template>

<script setup>

const selectOption = (option) => {
  emit('selected', option)
}

// Define emits for type checking (optional but recommended)
// eslint-disable-next-line 
const emit = defineEmits(['selected'])


</script>
<style scoped>
.option-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}
.option-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.option-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .option-icon {
    font-size: 2rem;
  }
  .card-body h5 {
    font-size: 1.1rem;
  }
}
</style>